import { render, staticRenderFns } from "./SendCopon.vue?vue&type=template&id=ca686394&scoped=true&"
import script from "./SendCopon.vue?vue&type=script&lang=js&"
export * from "./SendCopon.vue?vue&type=script&lang=js&"
import style0 from "./SendCopon.vue?vue&type=style&index=0&id=ca686394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca686394",
  null
  
)

export default component.exports